import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import { MenuItem } from 'material-ui/Menu';
import { CircularProgress } from 'material-ui/Progress';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card from 'material-ui/Card';
import Popover from 'material-ui/Popover';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import classNames from 'classnames';
import CancelIcon from '@material-ui/icons/Cancel';
import SettingsIcon from '@material-ui/icons/Settings';
import Switch from '@material-ui/core/Switch';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Close from 'material-ui-icons/Cancel';
import ReactTooltip from 'react-tooltip'
import PortfolioGroupForm from '../../../../containers/PortfolioGroupForm';
import addEditCustomer from '../../../../actions/addEditCustomer';
import addEditLocation from '../../../../actions/addEditLocation';
import search from '../../../../actions/search';
import getPortfolios from '../../../../actions/VXC/getPortfolios';
import storeInstitutionData from '../../../../actions/VXC/storeInstitutionData';
import storePortfolioFormData from '../../../../actions/VXC/storePortfolioFormData';
import managePortfolioData from '../../../../actions/VXC/managePortfolios';
import RenderDialog from '../../../../helpers/RenderDialog';
import renderCheckBoxGroup from '../../../../helpers/RenderCheckBoxGroup';

import renderTextField from '../../../../helpers/RenderTextFiledWithDiv';
import renderSelectField from '../../../../helpers/RenderSelectField';
import validationHelper from '../../../../helpers/ValidationHelper';
import normalizePhone from '../../../../helpers/NormalizePhone';

import RenderConfirmationTimeoutDialog from '../../../../helpers/RenderConfirmationTimeoutDialog';

import Layout from '../../../Layout';

const styles = theme => ({
    card: {
        display: 'flex',
        boxShadow: 'none',
    },
    content: {
        flex: '1 0 auto',
    },
    paperStyle: {
        width: '85%',
        height: '70%',
        maxWidth: '1075px',
        display: 'inline-block',
        margin: 20,
        marginTop: '5vh'
    },
    buttonStyle: {
        marginTop: 10,
        marginBottom: 15
    },
    marginStyle: {
        margin: 8
    },
    textField: {
        width: 350
    },
    textFieldportFolio: {
        width: '250px'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    radioGroup: {
        margin: '0 !important',
        textAlign: 'left',
    },
    radioGroupMask: {
        width: '300px',
        paddingTop: '20px'
    },
    radioGroupTest: {
        width: '350px',
        marginTop: '8px'
    },
    headerStyle: {
        position: 'relative',
        width: '100%',
        height: '60px',
        background: '#FFFFFF',
        boxShadow: 'none'
    },
    headerTitleStyle: {
        margin: '2%',
        fontSize: '24px',
        fontFamily: 'Roboto',
        display: 'flex',
        justifyContent: 'space-between'
    },
    addIcon: {
        position: 'absolute',
        margin: '1%'
    },
    root: {
        flexGrow: 1,
        height: 250,
    },
    input: {
        display: 'flex',
        padding: 0,
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
    },
    reportingLabel: {
        color: '#ADADAD',
        textAlign: 'left',
        marginLeft: '-70%',
        fontSize: '9pt'
    },
    chip: {
        margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
    },
    chipFocused: {
        backgroundColor: emphasize(
            theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
            0.08,
        ),
    },
    noOptionsMessage: {
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    singleValue: {
        fontSize: 14,
    },
    placeholder: {
        position: 'absolute',
        left: 2,
        fontSize: 14,
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    testClass: {
        display: 'block',
        width: '100%'
    }
});

function NoOptionsMessage(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.noOptionsMessage}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function inputComponent({ inputRef, ...props }) {
    return <div ref={inputRef} {...props} />;
}

function Control(props) {
    return (
        <TextField
            fullWidth
            InputProps={{
                inputComponent,
                inputProps: {
                    className: props.selectProps.classes.input,
                    inputRef: props.innerRef,
                    children: props.children,
                    ...props.innerProps,
                },
            }}
            {...props.selectProps.textFieldProps}
        />
    );
}

function Option(props) {
    return (
        <MenuItem
            buttonRef={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={{
                fontWeight: props.isSelected ? 500 : 400,
            }}
            {...props.innerProps}
        >
            {props.children}
        </MenuItem>
    );
}

function Placeholder(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.placeholder}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function SingleValue(props) {
    return (
        <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
            {props.children}
        </Typography>
    );
}

function ValueContainer(props) {
    return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

function MultiValue(props) {
    return (
        <Chip
            tabIndex={-1}
            label={props.children}
            className={classNames(props.selectProps.classes.chip, {
                [props.selectProps.classes.chipFocused]: props.isFocused,
            })}
            onDelete={props.removeProps.onClick}
            deleteIcon={<CancelIcon {...props.removeProps} />}
        />
    );
}

function Menu(props) {
    return (
        <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
            {props.children}
        </Paper>
    );
}

const components = {
    Control,
    Menu,
    MultiValue,
    NoOptionsMessage,
    Option,
    Placeholder,
    SingleValue,
    ValueContainer,
};

const validate = (values, props) => {
    const errors = validationHelper.validateRequired(['customer', 'portfolioType', 'portfolioName', 'contactName', 'addressLine1', 'billingAddress', 'address', 'phoneNumber', 'emailAddress', 'availableReports'], values);
    if (values.emailAddress && !validationHelper.validateEmail(values.emailAddress)) {
        errors.emailAddress = 'Invalid email address';
    }
    if (values.phoneNumber && !validationHelper.validatePhone(values.phoneNumber)) {
        errors.phoneNumber = 'Invalid phone number';
    }

    if (props.data && props.data.portfolioData) {
        if (props.data.portfolioData.Items.filter(x => x.name === values.portfolioName).length > 0) {
            errors.portfolioName = 'Name in use.  Please use another'
        }
    }

    const lengthValidation = [
        { field: 'customer', label: 'Customer', value: values.customer, min: 1, max: 50 },
        { field: 'contactName', label: 'Contact Name', value: values.contactName, min: 1, max: 50 },
        { field: 'phoneNumber', label: 'Phone Number', value: values.phoneNumber, min: 1, max: 12 },
        { field: 'emailAddress', label: 'Email Address', value: values.emailAddress, min: 1, max: 65 },
        { field: 'experianId', label: 'Primary Location Experian ID', value: values.experianId, min: 1, max: 50 },
        { field: 'address', label: 'Address', value: values.address, min: 1, max: 50 },
    ];
    validationHelper.validateLength(errors, lengthValidation);
    if (values.autotecId && !validationHelper.validateAutotecID(values.autotecId)) {
        errors.autotecId = '4 alphabetic characters + 4 numeric characters';
    }
    return errors;
};

const removeHyphens = (value) => {
    return value.replace(new RegExp('-', 'g'), '');
};

class AddEditPortfolio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            openAddress: false,
            fetching: false,
            saving: false,
            addressList: { Address: { addressType: 'Enter an address' } },
            addressType: '',
            hideOwnership: 'none',
            message: null,
            openDialog: false,
            addressPopulated: false,
            buttonColor: '#002053',
            autotecId: '',
            locationId: '',
            redirect: false,
            multi: null,
            custReports: [],
            portfolioData: [],
            newRecord: false,
            openEditGroup: false,
            allPortfolioData: [],
            allPortfolioDataResults: [],
            showEdit: false,
            portfolioId: '',
            customerData: [],
            alertOtherCustomers: false,
            portNameDup: false,
            disableField: false,
            maskName: '',
            postedFileSubmittals: '',
            setRuleChecks: false,
            portfolioReports: [
                { value: 'temptag', label: 'DMV Temp Tag', editGroup: false, fieldValue: '' },
                { value: 'active_port', label: 'Active Portfolio', editGroup: true, fieldValue: '' },
                { value: 'auct_unsold', label: 'Auction Unsold', editGroup: false, fieldValue: '' },
                { value: 'auct_early', label: 'Auction Sold Early', editGroup: false, fieldValue: '' },
                { value: 'sa_sold', label: 'SA Sold', editGroup: false, fieldValue: '' },
                { value: 'auct_sold', label: 'Auction Sold', editGroup: false, fieldValue: '' },
                { value: 'at_auction', label: 'At Auction', editGroup: false, fieldValue: '' }
            ],
        };
    }

    async componentDidMount() {
        this.setDefaultValues();
        if (this.props.match.params.id) {
            this.props.actions.getPortfolioData(this.props.match.params.id, this.props.data.config, this);
        }

        this.props.actions.getAllPortfolioInfo('', this.props.data.config, this);
    }



    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match !== this.props.match) {
            if (this.props.match.path.includes('add')) {
                this.setState({ newRecord: true })
            }
        }
    }

    setDefaultValues = () => {
        this.state.portfolioReports.map((report) => {
            this.props.dispatch(change('AddEditPortfolioForm', report.value, 'Yes'));
            this.props.dispatch(change('AddEditPortfolioForm', `${report.value}_SD`, this.setDefaultSubmissionDate(report.value)));
            this.props.dispatch(change('AddEditPortfolioForm', `${report.value}_DT`, 0));
        })
        this.props.dispatch(change('AddEditPortfolioForm', 'maskName', 'No'));
        this.props.dispatch(change('AddEditPortfolioForm', 'postedFileSubmittals', 'No'));
        this.props.dispatch(change('AddEditPortfolioForm', 'portfolioType', 'wholesale'));

        this.setState({ showEdit: true });
    }

    handleToggleChange = name => (event) => {
        this.setState({ [name]: event.target.checked });
    }

    buildLocation = (event, primaryLocationId, customerId) => {
        const address = this.state.addressList['Physical Address'].addressLine1 ?
            this.state.addressList['Physical Address'] :
            this.state.addressList['Billing Address'];

        const location = {
            contact: {
                contactName: event.contactName,
                emailAddress: event.emailAddress,
                phoneNumber: removeHyphens(event.phoneNumber)
            },
            address: {
                addressLine1: address.addressLine1,
                city: address.city,
                country: address.country,
                county: address.county,
                postalCode: address.postalCode,
                state: address.state,
            },
            locationName: event.customer,
            autotecId: event.autotecId,
            vhrOwnership: event.vhrOwnership
        };

        if (primaryLocationId) {
            location.locationId = primaryLocationId;
        }

        if (address.addressLine2) {
            location.address.addressLine2 = address.addressLine2;
        }

        if (customerId) {
            location.customerId = customerId;
        }

        return location;
    };



    buildAvailableReportsArray = (event) => {
        const availableReports = [];
        const { reportTypes } = this.props.data;
        Object.keys(event).forEach((key) => {
            const report = reportTypes.reportTypes.reportTypes.find(reportType => reportType.reportTypeId === key);
            if (report && report.methodId && event[key] === 'Yes') {
                availableReports.push(report.methodId);
            }
        });

        return availableReports;
    };

    handleSave = (event) => {
        this.setState({ saving: true });
        const portfolioData = this.buildPortfolioDataForSubmission(event);
        if (!this.props.match.params.id || this.state.newRecord) {
            this.props.actions.storePortfolioData(portfolioData);
            localStorage.setItem('portfolioData', JSON.stringify(portfolioData));
            this.props.history.push('/add-edit-portfolio-others');
        } else {
            let portId = portfolioData.portfolioId;
            const result = this.state.portfolioData.filter(portfolio => portfolio.portfolioId === portId);
            //ensure state is up to date when saving portfolio changes so they persist after changing portfolios
            result[0].rules = portfolioData.rules;
            result[0].postedFileSubmittals = portfolioData.postedFileSubmittals;
            result[0].maskName = portfolioData.maskName;
            result[0].directory = portfolioData.directory;
            result[0].portfolioType = portfolioData.portfolioType;
            this.props.actions.managePortfolioData(portfolioData, this.props.data.config, this);
        }
    };

    //set check boxes based on currently selected portfolio data
    //Triggered on load and after portfolio change
    setInitialChecks = (portfolioData) => {
        let customerReports = portfolioData['rules'];
        this.state.portfolioReports.map((report) => {
            let checked = customerReports.some(e => e.ruleId == report.value) ? 'Yes' : 'No';
            report.fieldValue = checked;
        });
        this.setState( {maskName: portfolioData.maskName === true ? 'Yes' : 'No'} )
        this.setState( {postedFileSubmittals: portfolioData.postedFileSubmittals } )
        this.setState( {setRuleChecks: true });
    }

    handleClear = () => {
        this.props.history.push('/customers');
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleAgree = () => {
        this.setState({ open: false });
    };

    handleAutotecIdChange = (event) => {
        this.props.dispatch(change('AddEditPortfolioForm', 'autotecPrefix', event.target.value.substr(0, 4)));
    };


    handleAddressClose = () => {
        this.setState({
            openAddress: false,
            anchorEl: null
        });
    };

    checkAddress = (address) => {
        if (Object.keys(address).length > 0) {
            this.setState({ addressPopulated: true });
        } else {
            this.setState({ addressPopulated: false });
        }
    }

    handleAddressSave = (addressList) => {
        this.checkAddress(addressList);
        localStorage.setItem('addressList', JSON.stringify(addressList));
        this.setState({
            addressList,
            openAddress: false
        });
    };

    setDefaultSubmissionDate = (evt) => {
        if (['active_port', 'sa_sold'].includes(evt)) {
            return '10'
        }
        return '2'
    }

    handleCheckChange = (event) => {
        const rulesFields = ['active_port', 'auct_early', 'auct_sold', 'sa_sold', 'temptag', 'auct_unsold', 'at_auction'];
        const targetName = event.target.name;
        const targetValue = event.target.value;

        if (targetValue === 'Yes') {
            if (targetName === 'active_port') {
                this.setState({ showEdit: true })
            }
            if (rulesFields.includes(targetName)) {
                this.props.dispatch(change('AddEditPortfolioForm', event.target.name, 'Yes'));
                this.props.dispatch(change('AddEditPortfolioForm', `${targetName}_DT`, '0'));
                this.props.dispatch(change('AddEditPortfolioForm', `${targetName}_SD`, this.setDefaultSubmissionDate(targetName)));
                this.setState((prevState, props) => {
                    const newReports = prevState.portfolioReports;
                    const index = newReports.findIndex(item => item.value === targetName);
                    newReports[index].fieldValue = targetValue;
                    return { portfolioReports: newReports };
                });
            } else {
                this.props.dispatch(change('AddEditPortfolioForm', `${targetName}`, targetValue));
                this.setState({ [targetName]: targetValue });
            }
        } else {
            this.setState({ showEdit: false });
            if (rulesFields.includes(targetName)) {
                this.props.dispatch(change('AddEditPortfolioForm', `${targetName}_DT`, ''));
                this.props.dispatch(change('AddEditPortfolioForm', `${targetName}_SD`, ''));
                this.setState((prevState, props) => {
                    const newReports = prevState.portfolioReports;
                    const index = newReports.findIndex(item => item.value === targetName);
                    newReports[index].fieldValue = targetValue;

                    return { portfolioReports: newReports };
                });
            } else {
                this.props.dispatch(change('AddEditPortfolioForm', `${targetName}`, targetValue));
                this.setState({ [targetName]: targetValue });
            }

        }
    }

    handleAgree = () => {
        this.props.history.push('/customers');
    }

    handleClose = () => {
        this.setState({ openDialog: false, fetching: false, saving: false });
    }

    saveAlert = () => {
        let dialog = <div />;
        if (this.state.openDialog) {
            dialog =
            (<RenderConfirmationTimeoutDialog
                open={this.state.openDialog}
                stayInAction={() => { this.handleClose(); }}
                handleIdleTimeout={() => { this.handleAgree(); }}
                timeoutInterval={this.props.data.config.ConfirmationTimeout}
                page={this.props.match.params.id ? 'Edit Portfolio' : 'Add Portfolio'}
            />);
        } else {
            dialog = (<div />);
        }
        return dialog;
    }

    changeButtonColor = () => {
        this.setState({ buttonColor: '#3f51b5' });
    }

    handleConfirmSaved = () => {
        if (!this.props.data.addEditCustomer.saved && !this.props.data.addEditLocation.saved) {
            return true;
        }
        return false;
    }

    handleChange = name => value => {
        this.setState({
            [name]: value
        });
    };

    buildPortfolioDataForSubmission = (event) => {
        const rules = [];
        const fields = ['temptag', 'active_port', 'auct_unsold', 'auct_early', 'sa_sold', 'auct_sold', 'at_auction']

        const institutionalData = JSON.parse(localStorage.getItem('institutionData'));

        Object.keys(event).forEach((key) => {
            if (fields.includes(key) && event[key] === 'Yes') {

                const rule = {
                    delayDate: event[`${key}_DT`],
                    ruleId: key,
                    suppressionDate: event[`${key}_SD`]
                }
                if (key === 'active_port') {
                    rule.institutions = institutionalData;
                }
                //only add rules if they have defined delayDate and suppressionDates
                if (rule.delayDate && rule.suppressionDate) {
                    rules.push(rule);
                }
            }
        });

        const portfolioData = {
            customerId: this.props.match.params.id,
            name: event.name ? event.name.trim() : event.portfolioName.trim(),
            directory: event.directory,
            portfolioType: event.portfolioType,
            portfolioId: event.autotecId,
            autotecId: event.autotecId,
            alertOtherCustomers: this.state.alertOtherCustomers,

            maskName: event.maskName === 'Yes' ? true : false,
            postedFileSubmittals: event.postedFileSubmittals,
            rules: rules
        }
        return portfolioData;
    }

    handleNewPortfolioNameCheck = (event) => {
        if (this.state.newRecord) {
            if (this.state.portfolioData.filter(x => x.name === event.target.value).length > 0) {
                this.setState({ portNameDup: true });
            } else {
                this.setState({ portNameDup: false });
            }
        }
    }

    handlePortfolioChange = (event) => {

        const rulesFields = ['active_port', 'auct_early', 'auct_sold', 'sa_sold', 'temptag', 'auct_unsold', 'at_auction'];
        const otherFields = ['maskName', 'postedFileSubmittals', 'directory'];

        otherFields.forEach((field) => {
            this.props.dispatch(change('AddEditPortfolioForm', field, 'No'));
        });

        
        const portfolioId = event ? event.target.value : this.state.portfolioData && this.state.portfolioData.length !== 0 ? this.state.portfolioData[0].portfolioId : "";
        const result = this.state.portfolioData.filter(portfolio => portfolio.portfolioId === portfolioId);
        this.props.actions.getAllPortfolioInfo(result[0].portfolioId, this.props.data.config, this);

        //This is a portfolio change and not initial load, reset checkboxes
        if (event && event.target.value) {
            this.setInitialChecks(result[0]);
        }

        if (result[0].alertOtherCustomers) {
            this.setState({ alertOtherCustomers: true });
        } else {
            this.setState({ alertOtherCustomers: false });
        }

        this.props.dispatch(change('AddEditPortfolioForm', 'autotecId', result[0].portfolioId));

        this.setState({ portfolioId: result[0].portfolioId });

        const editGroups = [];

        result[0].rules.forEach((rule) => {
            if (rule.ruleId === 'active_port' && rule.hasOwnProperty('institutions')) {
                rule.institutions.forEach((r) => {
                    const data = {
                        portfolioId: r.portfolioId,
                        delayDate: r.delayDate,
                        suppressionDate: r.suppressionDate
                    }
                    editGroups.push(data);
                })
            }
            localStorage.setItem('institutionData', JSON.stringify(editGroups))
            this.props.actions.storeInstitutionData(editGroups);
        });

        Object.keys(result[0]).forEach((key) => {
            if (key === 'maskName') {
                switch (result[0][key]) {
                    case true:
                        this.props.dispatch(change('AddEditPortfolioForm', key, 'Yes'));
                        break;
                    default:
                        this.props.dispatch(change('AddEditPortfolioForm', key, 'No'));
                }

            } else {
                this.props.dispatch(change('AddEditPortfolioForm', key, result[0][key]));
            }
        })

        rulesFields.forEach((field) => {
            this.props.dispatch(change('AddEditPortfolioForm', field, 'No'))
            this.props.dispatch(change('AddEditPortfolioForm', `${field}_DT`, ''))
            this.props.dispatch(change('AddEditPortfolioForm', `${field}_SD`, ''))

        })

        !this.state.setRuleChecks && this.setInitialChecks(result[0]);
        result[0]['rules'].map((res) => {
            this.setState({ customerData: result[0]['rules'] });
            Object.keys(res).forEach((key) => {
                if (rulesFields.includes(res[key])) {
                    (res[key] === 'active_port') ? this.setState({ showEdit: true }) : null
                    this.props.dispatch(change('AddEditPortfolioForm', res[key], 'Yes'))
                    this.props.dispatch(change('AddEditPortfolioForm', `${res[key]}_DT`, res.delayDate));
                    this.props.dispatch(change('AddEditPortfolioForm', `${res[key]}_SD`, res.suppressionDate));
                }
            })
        })
    }

    handleEditGroupOpen = (event) => {
        this.setState({
            openEditGroup: true,
            anchorEl: event.currentTarget
        })
    }

    handleEditGroupClose = () => {
        this.setState({ openEditGroup: false })
    }

    handleEditRecordData = (value) => {
        this.setState({ allPortfolioDataResults: value });
    }

    render() {
        const dialog = this.saveAlert();
        const optionsList = [{ id: 1, label: 'Yes' }, { id: 2, label: 'No' }];

        const { classes, handleSubmit, theme } = this.props;
        const portfolioItems = (
            this.state.portfolioData.map((portfolio) => {
                return (<MenuItem value={portfolio.portfolioId}>{portfolio.name}</MenuItem>)
            })
        )
        
        const renderReportOptions = this.state.portfolioReports.map((report, index) => (
            <Fragment key={index}>
                <div className="firstItem">
                    <Field
                        name={report.value}
                        component={renderCheckBoxGroup}
                        options={optionsList}
                        className={classes.radioGroupMask}
                        label={report.label}
                        checked={report.fieldValue}
                        handleCheckChange={this.handleCheckChange}
                    />
                </div>
                <div className="secondItem">
                    <Field
                        name={`${report.value}_SD`}
                        component={renderTextField}
                        label="Suppression Days"
                        className="width150"
                        divClassName={classes.marginStyle}
                    />
                </div>
                <div className="thirdItem">
                    <Field
                        name={`${report.value}_DT`}
                        component={renderTextField}
                        label="Delay Time"
                        className="width150"
                        divClassName={classes.marginStyle}
                    />
                </div>
            </Fragment>
        ))

        if (!this.props.match.params.id) {
            this.props.dispatch(change('AddEditPortfolioForm', 'vhrOwnership', 'No'));
        }

        const selectStyles = {
            input: base => ({
                ...base,
            }),
        };

        let button = <div align="center"><CircularProgress size={75} /></div>;

        if (!this.props.match.params.id || this.state.newRecord) {
            button = (<Button variant="raised"
                disabled={this.state.portNameDup}
                style={this.state.portNameDup ? { background: '#ddd' } : { background: '#002053' }}
                type="submit">Next</Button>);
        } else {
            button = (<Button variant="raised"
                style={!this.props.valid || this.state.saving ? { background: '#ddd' } : { background: '#002053' }}
                disabled={!this.props.valid || this.state.saving}
                type="submit">{this.state.saving ? 'Please wait...' : 'Save'}</Button>);
        }

        const portfolioField = (this.state.newRecord) ?
            (
                <Field
                    name="portfolioName"
                    component={renderTextField}
                    label="Portfolio Name"
                    className={classes.textFieldTest}
                    divClassName={classes.marginStyle}
                    onChange={this.handleNewPortfolioNameCheck}
                />) :
            (<Field
                name="portfolioName"
                component={renderSelectField}
                label="Portfolio Name"
                className={classes.textFieldTest}
                divClassName={classes.formControl}
                children={portfolioItems}
                onChange={this.handlePortfolioChange}
            />)

        return (
            <Layout
                className="App"
                showMenu
                menuTitle=""
                toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
            >
                <ReactTooltip />
                <Paper className={classes.paperStyle}>
                    {dialog}
                    {/* <Prompt
                        when={this.handleConfirmSaved}
                        message="Any changes will be lost if you leave this screen. Would you like to continue?"
                    /> */}
                    <AppBar position="static" className={classes.headerStyle}>
                        <Toolbar className={classes.headerTitleStyle}>
                            <Typography variant="title" className="lightH2">
                                <span className="pageHeader" style={{ fontSize: '24px' }}>{(this.props.match.params.id && !this.state.newRecord) ? 'Edit' : 'Add'} Portfolio Configurations</span>
                            </Typography>
                            <IconButton title="close" component={Link} to="/customers">
                                <Close color="disabled" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Form key="AddEditPortfolioForm" onSubmit={handleSubmit((event) => { this.setState({ saving: true }); this.handleSave(event); })}>
                    {
                        this.state.fetching ?
                        <div align="center"><CircularProgress size={75} /></div>
                        :
                        <Card className={classes.card}>
                            {/* <CardContent className={classes.content}> */}
                            <div className="wrapperForGrid">
                                <div className="testingCSSGrid">
                                    <div className="firstOne">
                                        {portfolioField}
                                    </div>
                                    <div className="newOne">
                                        <Field
                                            name="portfolioType"
                                            component={renderSelectField}
                                            label="Portfolio Type"
                                            className={classes.textFieldTest}
                                            divClassName={classes.formControl}>
                                            <MenuItem value='wholesale'>Wholesale</MenuItem>
                                            <MenuItem value='retail'>Retail</MenuItem>
                                        </Field>
                                    </div>
                                    <div className="secondOne">
                                        <Field
                                            name="maskName"
                                            component={renderCheckBoxGroup}
                                            options={optionsList}
                                            className={classes.radioGroupTest}
                                            label="Mask Name"
                                            checked={this.state.maskName}
                                            handleCheckChange={this.handleCheckChange}
                                        />
                                    </div>
                                    <div className="thirdOne">
                                        <Field
                                            name="directory"
                                            component={renderTextField}
                                            label="Directory"
                                            className={classes.textFieldTest}
                                            divClassName={classes.marginStyle}
                                        />
                                    </div>
                                    <div className="fifthOne">
                                        <Field
                                            name="autotecId"
                                            component={renderTextField}
                                            label="AutoTec Id"
                                            disabled={true}
                                            className={classes.textFieldTest}
                                            divClassName={classes.marginStyle}
                                        />
                                    </div>
                                    <div className="fourthOne">
                                        <Field
                                            name="postedFileSubmittals"
                                            component={renderCheckBoxGroup}
                                            options={optionsList}
                                            className={classes.radioGroupTest}
                                            label="Posted File Submittals"
                                            checked={this.state.postedFileSubmittals}
                                            handleCheckChange={this.handleCheckChange}
                                        />
                                    </div>
                                </div>

                                <div className="sixthOne">
                                    <span className="togglePortfolioEnable">
                                        <span
                                            data-tip={this.state.alertOtherCustomers ?
                                                'Does create alerts on other portfolios.' :
                                                'Does not create alerts on other portfolios.'
                                            }>

                                            <Switch
                                                checked={this.state.alertOtherCustomers}
                                                onChange={this.handleToggleChange('alertOtherCustomers')}
                                                value='alertOtherCustomers'
                                                name="alertOtherCustomers"
                                            />
                                        </span>
                                        <span style={{ margin: '0', padding: '0', color: '#757575' }}>{this.state.alertOtherCustomers ? 'ENABLED' : 'DISABLED'}</span>
                                    </span>
                                    <span className="edit-group">
                                        <a href="#" data-tip="Edit Group" className="editGroupBtn" onClick={this.handleEditGroupOpen}>
                                            <SettingsIcon />
                                        </a>
                                        <span style={{ padding: 0, margin: 0, alignSelf: 'center', color: '#757575' }}>EDIT GROUPS</span>
                                    </span>
                                </div>


                                {/* <div style={{ minWidth: '1000px', display: 'inline-block' }}> */}
                                <div className="testingCSSGrid1">
                                    {renderReportOptions}
                                </div>
                                {/* </CardContent> 
                            </div> */}
                            </div>
                        </Card>
                    }
                        <div className={classes.buttonStyle}>
                            {button}
                        </div>
                        <div>
                            <Popover
                                open={this.state.openEditGroup}
                                anchorEl={this.state.anchorEl}
                                onClose={this.handleEditGroupClose}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'center',
                                    horizontal: 'left',
                                }}
                                disableRestoreFocus
                            >
                                <PortfolioGroupForm
                                    customerId={this.props.match.params.id}
                                    portfolioId={this.state.portfolioId}
                                    customerData={this.state.customerData}
                                    customerPortfolio={this.state.portfolioData[0] ? this.state.portfolioData[0] : ''}
                                    editRecordData={this.handleEditRecordData}
                                    newRecord={this.state.newRecord}
                                    portfolioData={this.state.allPortfolioData}
                                    handleAddressSave={this.handleAddressSave}
                                    addressType={this.state.addressType}
                                    handleAddressClose={this.handleEditGroupClose}
                                    addressList={this.state.addressList}
                                />
                            </Popover>
                        </div>
                    </Form>
                </Paper>
            </Layout >
        );
    }
}

AddEditPortfolio.propTypes = {
    classes: PropTypes.shape().isRequired,
    theme: PropTypes.object.isRequired,
};

const initialValues = (customers, reportTypes, ownProps) => {
    const customer = (customers.customers) ?
        customers.customers.customers.filter(item => item.customerId === ownProps.match.params.id)[0] :
        {};

    let values = {};
    if (customer && customer.name && reportTypes.reportTypes) {
        values = {
            customer: customer.name,
            customerGroup: customer.customerGroupId,
            contactName: customer.contact.contactName,
            phoneNumber: normalizePhone(customer.contact.phoneNumber),
            emailAddress: customer.contact.emailAddress,
            invoiceMin: customer.invoiceMinAmount,
            invoiceMax: customer.invoiceMaxAmount,
            autotecPrefix: customer.autotecId.substr(0, 4),
            autotecId: customer.autotecId,
            experianId: customer.experianId
        };

        const reports = [];
        customer.authorizedMethodIds.forEach((methodId) => {
            const report = reportTypes.reportTypes.reportTypes.filter(reportType => reportType.methodId === methodId);
            if (report) {
                reports.push(report[0]);
            }
        });

        //defaults all reports to 'No'
        reportTypes.reportTypes.reportTypes.forEach((report) => {
            values[report.reportTypeId] = 'No';
        });

        // changes reports to Yes if customer has report
        reports.forEach((report) => {
            if (report && report.reportTypeId) {
                values[report.reportTypeId] = 'Yes';
            }
        });
    }
        else {
                if (reportTypes && reportTypes.reportTypes) {
                reportTypes.reportTypes.reportTypes.forEach((report) => {
                    values[report.reportTypeId] = 'No';
                });
            }
        }
    return values;
};

const mapStateToProps = (state, ownProps) => ({
    data: {
        addEditCustomer: state.addEditCustomer,
        portfolioData: state.portfolios.portfolios,
        portfolioFormData: state.portfolioFormData,
        addEditLocation: state.addEditLocation,
        customers: state.customers,
        customerGroups: state.customerGroups,
        reportTypes: state.reportTypes,
        locations: state.search.locations,
        config: state.config.config,
        error: state.error,
        institutionData: state.institutionData
    },
    initialValues: initialValues(
        state.customers,
        state.reportTypes,
        ownProps
    )
});

const mapDispatchToProps = dispatch => ({
    actions: {
        saveCustomer: (customer, location, config, self) => {
            self.setState({ saving: true });
            const newLocation = location;
            const newCustomer = customer;
            const isNewCustomer = (customer.customerId === undefined || customer.customerId === null);
            self.setState({
                buttonColor: '#ddd',
                addressList: { Address: { addressType: 'Address' } },
                addressType: ''
            });
            dispatch(addEditLocation(newLocation, config)).then(
                (o) => {
                    self.setState({ saving: true });
                    if (o.action.type === 'ADD_EDIT_LOCATION_SAVE_FULFILLED') {
                        const { locationId } = o.value.data;
                        newLocation.locationId = locationId;
                        newCustomer.primaryLocationId = locationId;
                        dispatch(addEditCustomer(newCustomer, config)).then((p) => {
                            if (p.action.type === 'ADD_EDIT_CUSTOMER_SAVE_FULFILLED') {
                                const { customerId } = p.value.data;
                                newLocation.customerId = customerId;
                                dispatch(addEditLocation(newLocation, config)).then((q) => {
                                    if (q.action.type === 'ADD_EDIT_LOCATION_SAVE_FULFILLED') {
                                        if (isNewCustomer) {
                                            self.props.history.push(`/add-edit-billing-information/customer/${customerId}`);
                                        } else {
                                            self.setState({ addressList: JSON.parse(localStorage.getItem('addressList')) })
                                            self.setState({ message: 'Record saved', openDialog: true, fetching: false, saving: false, buttonColor: '#3f51b5' });
                                        }
                                    }
                                });
                            }
                        });
                    }
                }).catch(() => {
                    self.setState({ buttonColor: '#3f51b5' })
                });
            self.setState({ saving: false, fetching: false, addressList: JSON.parse(localStorage.getItem('addressList')) })
        },
        managePortfolioData: (portfolioData, config, self) => {
            self.setState({ saving: true });
            dispatch(managePortfolioData(portfolioData, config)).then((p) => {
                if (p.action.type === 'ADD_EDIT_PORTFOLIOS_SAVE_FULFILLED') {
                    self.setState({ saving: false, saved: true, message: 'Record saved', openDialog: true });
                }
            })
        },
        getPortfolioData: (customerId, config, self) => {
            self.props.dispatch(change('AddEditPortfolioForm', 'autotecId', ''));
            self.setState({ fetching: true });
            dispatch(getPortfolios(customerId, config)).then((portfolioData) => {
                if (portfolioData.action.type === 'PORTFOLIOS_FETCH_FULFILLED') {
                    self.setState({ fetching: false });
                    if (portfolioData.action.payload.data.Items.length > 0) {
                        let value = 0;
                        let autotecPrefix = '';
                        let autotecValue = 0;
                        portfolioData.action.payload.data.Items.forEach((portfolio) => {
                            if (portfolio.autotecId) {
                                if (value < parseInt(portfolio.autotecId.substring(8, 4))) {
                                    autotecPrefix = portfolio.autotecId.substring(0, 4);
                                    value = parseInt(portfolio.autotecId.substring(8, 4));
                                    autotecValue = (value + 1) + '';
                                    autotecValue.substr(autotecValue.length - 4)
                                    while (autotecValue.length < 4) autotecValue = '0' + autotecValue;
                                    autotecValue = `${autotecPrefix}${autotecValue}`;
                                    self.setState({ disableField: true })
                                    // self.props.dispatch(change('AddEditPortfolioForm', 'autotecId', autotecValue));
                                }
                            }
                        });
                        self.setState({ portfolioData: portfolioData.action.payload.data.Items, newRecord: false, showEdit: true }, () => {
                            self.props.dispatch(change('AddEditPortfolioForm', 'portfolioName', portfolioData.action.payload.data.Items[0].portfolioId));
                            self.handlePortfolioChange();
                        });
                    } else {
                        self.setState({ newRecord: true })
                    }
                }
            })
        },
        getAllPortfolioInfo: (portfolioId, config, self) => {
            dispatch(search('portfolios', 0, null, config)).then((portfolioData) => {
                if (portfolioData.action.payload.data.items.length > 0) {
                    const portData = portfolioData.action.payload.data.items.filter(x => x.portfolioId !== portfolioId)
                    self.setState({ allPortfolioData: portData });
                }
            })
        },
        storeInstitutionData: (value) => {
            dispatch(storeInstitutionData(value));
        },
        storePortfolioData: (value) => {
            dispatch(storePortfolioFormData(value));
        }

    }
});

const ReduxForm = withStyles(styles, { withTheme: true })(reduxForm({
    form: 'AddEditPortfolioForm',
    enableReinitialize: true,
    validate
})(AddEditPortfolio));

const ConnectedAddEditCustomer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ReduxForm);

export default ConnectedAddEditCustomer;


// WEBPACK FOOTER //
// ./src/components/Customer/Customer/VXC/AddEditPortfolio.js